import create, { SetState, GetState } from 'zustand';

const stateDefault = {
  selected: null,
  result: {},
  page: 1,
  keywords: '',
  createModal: false,
  idRombel: '',
  idStudents: '',
  selectedStudentIds: [],
};

const actions = (set, get) => ({
  setResult: (payload) => {
    set((state) => ({
      ...state,
      result: payload,
    }));
  },
  setSelected: (payload) => {
    set((state) => ({
      ...state,
      selected: payload,
    }));
  },

  setCreateModal: () => {
    set((state) => ({
      ...state,
      createModal: !state.createModal,
    }));
  },

  setSelectedStudentIds: (payload) => {
    set((state) => ({
      ...state,
      selectedStudentIds: payload,
    }));
  },
});

export const useRombel = create((set, get) => ({
  ...stateDefault,
  ...actions(set, get),
}));
